// section-feature-columns.js
(function() {
  'use strict';

  var swiperInstances = new WeakMap();

  // 从 data 属性获取配置
  function getConfig(container) {
    var section = container.closest('[data-section-id]');
    if (!section) return null;

    return {
      sectionId: section.dataset.sectionId || '',
      colDK: parseInt(section.dataset.colDk, 10) || 3,
      colTB: parseInt(section.dataset.colTb, 10) || 2,
      colMB: parseInt(section.dataset.colMb, 10) || 1,
      navUI: section.dataset.navUi === 'true',
      dotUI: section.dataset.dotUi === 'true',
    };
  }

  function initSwiper(container) {
    if (container.swiper || swiperInstances.has(container)) return;

    var config = getConfig(container);
    if (!config) return;

    var colDK = config.colDK;
    var colTB = config.colTB;
    var colMB = config.colMB;
    var navUI = config.navUI;
    var dotUI = config.dotUI;

    var slides = container.querySelectorAll('.swiper-slide');
    var slideCount = slides.length;

    if (slideCount <= 1) {
      container.style.overflow = 'visible';
      return;
    }

    var prevEl = container.querySelector('.swiper-button-prev');
    var nextEl = container.querySelector('.swiper-button-next');
    var paginationEl = container.querySelector('.swiper-pagination');

    var swiperConfig = {
      slidesPerView: colMB,
      spaceBetween: 15,
      loop: false,
      speed: 500,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      breakpoints: {
        768: {
          slidesPerView: Math.min(colTB, slideCount),
          spaceBetween: 20,
        },
        1150: {
          slidesPerView: Math.min(colDK, slideCount),
          spaceBetween: 30,
        }
      }
    };

    if (navUI && prevEl && nextEl && slideCount > colDK) {
      swiperConfig.navigation = {
        nextEl: nextEl,
        prevEl: prevEl,
      };
    } else {
      if (prevEl) prevEl.style.display = 'none';
      if (nextEl) nextEl.style.display = 'none';
    }

    if (dotUI && paginationEl && slideCount > colDK) {
      swiperConfig.pagination = {
        el: paginationEl,
        clickable: true,
        dynamicBullets: true,
      };
    } else {
      if (paginationEl) paginationEl.style.display = 'none';
    }

    if (slideCount <= colDK) {
      swiperConfig.allowTouchMove = false;
    }

    var swiper = new Swiper(container, swiperConfig);
    swiperInstances.set(container, swiper);
  }

  function initAllSliders() {
    var containers = document.querySelectorAll('.hdt-feature-columns .swiper');
    containers.forEach(function(container) {
      if (container.swiper || swiperInstances.has(container)) return;
      if (container.offsetParent !== null) {
        initSwiper(container);
      }
    });
  }

  function observeSliders() {
    var containers = document.querySelectorAll('.hdt-feature-columns .swiper');

    if (!containers.length) return null;

    if (!('IntersectionObserver' in window)) {
      if (typeof Swiper !== 'undefined') {
        initAllSliders();
      }
      return null;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var container = entry.target;
          if (!container.swiper && !swiperInstances.has(container)) {
            if (typeof Swiper !== 'undefined') {
              initSwiper(container);
            } else {
              var checkSwiper = setInterval(function() {
                if (typeof Swiper !== 'undefined') {
                  clearInterval(checkSwiper);
                  initSwiper(container);
                }
              }, 100);
              setTimeout(function() {
                clearInterval(checkSwiper);
              }, 5000);
            }
          }
        }
      });
    }, {
      rootMargin: '200px',
      threshold: 0.01,
    });

    containers.forEach(function(container) {
      observer.observe(container);
    });

    return observer;
  }

  function destroyAllSliders() {
    var containers = document.querySelectorAll('.hdt-feature-columns .swiper');
    containers.forEach(function(container) {
      if (swiperInstances.has(container)) {
        try {
          swiperInstances.get(container).destroy(true, true);
        } catch (e) {}
        swiperInstances.delete(container);
      }
      if (container.swiper) {
        try {
          container.swiper.destroy(true, true);
        } catch (e) {}
      }
    });
  }

  var observer = null;

  function initialize() {
    destroyAllSliders();

    if (typeof Swiper !== 'undefined') {
      observer = observeSliders();
      initAllSliders();
    } else {
      var checkSwiper = setInterval(function() {
        if (typeof Swiper !== 'undefined') {
          clearInterval(checkSwiper);
          observer = observeSliders();
          initAllSliders();
        }
      }, 100);

      setTimeout(function() {
        clearInterval(checkSwiper);
      }, 5000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    if (window.requestAnimationFrame) {
      requestAnimationFrame(initialize);
    } else {
      initialize();
    }
  }

  window.addEventListener('unload', function() {
    destroyAllSliders();
    if (observer && typeof observer.disconnect === 'function') {
      observer.disconnect();
    }
  });

  document.addEventListener('shopify:section:load', function(e) {
    var section = e.detail.section;
    if (section && section.classList.contains('hdt-feature-columns')) {
      setTimeout(function() {
        var containers = section.querySelectorAll('.swiper');

        containers.forEach(function(container) {
          if (swiperInstances.has(container)) {
            try {
              swiperInstances.get(container).destroy(true, true);
            } catch (err) {}
            swiperInstances.delete(container);
          }
          if (container.swiper) {
            try {
              container.swiper.destroy(true, true);
            } catch (err) {}
          }
        });

        if (typeof Swiper !== 'undefined') {
          containers.forEach(function(container) {
            if (container.offsetParent !== null) {
              initSwiper(container);
            }
          });
        }
      }, 100);
    }
  });

})();